import { render } from "./modal_receptiondouchette_resto.vue?vue&type=template&id=2105521c&scoped=true"
import script from "./modal_receptiondouchette_resto.vue?vue&type=script&lang=js"
export * from "./modal_receptiondouchette_resto.vue?vue&type=script&lang=js"

import "./modal_receptiondouchette_resto.vue?vue&type=style&index=0&id=2105521c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2105521c"]])

export default __exports__